/**
 * Generate an avatar URL for a user.
 * Uses UI Avatars API as a fallback when no avatar is provided.
 * @param name - The user's name
 * @param email - The user's email (optional, for Gravatar support)
 * @param avatar - The user's existing avatar URL (if any)
 * @returns A valid avatar URL
 */
export function getAvatarUrl(
  name?: string | null,
  avatar?: string | null
): string | undefined {
  // If user has a custom avatar, use it
  if (avatar) {
    return avatar;
  }

  // Generate a fallback avatar using UI Avatars
  // This service generates avatars with initials
  if (name) {
    const encodedName = encodeURIComponent(name);
    // Using UI Avatars API with a nice color scheme
    return `https://ui-avatars.com/api/?name=${encodedName}&background=6366f1&color=ffffff&bold=true&size=128`;
  }

  return undefined;
}

/**
 * Get initials from a name for avatar fallback
 * @param name - The user's name
 * @returns The initials (1-2 characters)
 */
export function getInitials(name?: string | null): string {
  if (!name) return '?';
  
  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) {
    return parts[0].charAt(0).toUpperCase();
  }
  return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
}
